module.exports = __webpack_public_path__ + "img/lcc1.422ef5fe.png";